import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { PaymentPromoModal } from "./paymentPromoModal";
import { gaPackageBrowselinkedSection, gaPackageBrowseShopOrCustomizeClick } from '../../util/googleAnalytics';
import { LinkedProducts } from "../col-grad-annc/linkedProductModal";
import { formatPrice } from "../../util/formatPrice";
import { useAfterPayInjectionScript } from '../../hooks';
import { uniqueId } from 'lodash';

export const PaymentPromo = React.memo(({ hsPaymentPromo, product, isBannerMode, fromGradPackages, altImage, showAfterPay = false }) => {
    const [paymentOptionsData, setPaymentOptionsData] = useState("")
    const [showModal, setShowModal] = useState(false)
    const [paymentData, setPaymentData] = useState({});
    const [showCustomize, setShowCustomize] = useState(false);
    const [linkedProducts, setLinkedProducts] = useState([]);

    const priceValue = product?.[fromGradPackages?'packagePrice':'retailPrice']
    const price = formatPrice(priceValue, product?.currencyCode)
    const [isAfterPayLoaded, setIsAfterPayLoaded] = useState()
    const [showPaymentOptions, setShowPaymentOptions] = useState()

    const afterPayContainerId = React.useMemo(() => uniqueId('jos-after-pay-container-'), []);

    useAfterPayInjectionScript(setIsAfterPayLoaded);

    useEffect(() => {
        const excludeForCatOsr = ["GRAD_PROD_HS_SENIOR_NATIONAL_SPRING_CATALOG", "GRAD_PROD_HS_SENIOR_SPRING_CATALOG"]
        if (product) {
            if (!Boolean(excludeForCatOsr.find((osrValue) => osrValue === product.catClassRefcode))) {
                const customerNumber = product.cacheKey?.split("-")[0]
                const url = `${process.env.REACT_APP_BASE_PATH}/apps/checkout/productPaymentPlanDetails.mvc?productType=${product.productType}&categoryName=${hsPaymentPromo.categoryOsr}&currentPrice=${product[fromGradPackages?'packagePrice':'retailPrice']}&currencyCode=${product.currencyCode}&customerNumber=${customerNumber}`

                url && axios.get(url,
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                    .then(result => {
                        let displayText = ""
                        setPaymentData(result.data);
                        if (result.data?.numberOfPayments > 1) {
                            displayText = hsPaymentPromo?.displayText
                                ?.replace('{totalPrice}', `$${product[fromGradPackages?'packagePrice':'retailPrice']}`)
                                ?.replace('{numberOfPayments}', result.data?.numberOfPayments)
                                ?.replace('{price}', `$${result.data.payments?.length > 0 && result.data.payments[0]} <img src=${hsPaymentPromo?.imageUrl} alt="Jpay logo" height=${17}></img>`)
                        } else {
                            displayText = result.data.payments?.length > 0 && '$' + result.data.payments[0]
                        }
                        setPaymentOptionsData(displayText)
                    })
            }
        }

    }, [product, hsPaymentPromo])

    const onCtaBtnClick = () => {
		if(product?.linkedProducts?.length > 1 && !fromGradPackages) {
            gaPackageBrowselinkedSection(product)
			setShowCustomize(true)
			setLinkedProducts(product.linkedProducts);
		} else if(product?.linkedProducts?.length === 1 && !fromGradPackages) {
            gaPackageBrowseShopOrCustomizeClick(product, "Banner")
            gaPackageBrowselinkedSection(product?.linkedProducts[0].publishedCatalogProductId)
			window.location.href = product?.linkedProducts[0].actionUrl;
		} else {
            gaPackageBrowseShopOrCustomizeClick(product, "Banner")
			window.location.href = product.actionUrl;
		}
	}

    useEffect(() => {
        if(!product.retailPrice || !isAfterPayLoaded) {
            return;
        }
        if(window.jostensAfterPay?.enabled) {
            window.jostensAfterPay.showAfterPayMessage({
                amount: product.retailPrice,
                productOsr: product.productOsr,
                currency: product.currencyCode,
                containerId: '#' + afterPayContainerId
            })
        } else {
            if(paymentOptionsData && paymentData?.numberOfPayments > 1) {
                setShowPaymentOptions(true);
            }
        }
    }, [isAfterPayLoaded, product.retailPrice, product])

    return (
        <div className={isBannerMode ? 'container-fluid ml-3' : ''}> 
            <div className="price mb-2">{price}</div>
            
            {showPaymentOptions &&
                (<div className="d-inline-flex">
                    <div className='mb-2 fontSizeSM' dangerouslySetInnerHTML={{ __html: paymentOptionsData }} />
                    <i className="fas fa-info-circle ml-1" onClick={()=> setShowModal(true)}></i>
                </div>)
            }
            {showAfterPay &&
                <div id={afterPayContainerId}></div>
            }
            {isBannerMode &&
                (<div className='pb-3'>
                    <button type="button" className="btn btn-primary" onClick={()=>onCtaBtnClick()}>{hsPaymentPromo.buttonCta}</button>
                </div>)
            }
            <PaymentPromoModal showModal={showModal} handleClose={()=>setShowModal(false)} hsPaymentPromo={hsPaymentPromo} paymentData={paymentData} retailPrice={product?.[fromGradPackages?'packagePrice':'retailPrice']}/>
            {showCustomize && <LinkedProducts linkedProducts={linkedProducts} showCustomize={showCustomize} setShowCustomize={setShowCustomize} product={product} altImage={altImage} />}
        </div>
    )
})